var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", { staticClass: "text-gray mb-0" }, [
      _vm._v("\n    " + _vm._s(_vm.eventInfo.title) + "\n  "),
    ]),
    _vm._v(" "),
    _vm.eventInfo.owner
      ? _c("span", { staticClass: "text-muted font-sm" }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t("dashboard.calendar.organizer")) +
              " " +
              _vm._s(_vm.eventInfo.owner) +
              "\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "calendar-popover-body mt-2" },
      [
        _c(
          "b-row",
          { staticClass: "mb-2" },
          [
            _c(
              "b-col",
              {
                staticClass: "event-icon-col text-center pr-0",
                attrs: { cols: "auto" },
              },
              [
                _c("i", {
                  staticClass: "text-primary fa fa-clock-o task-calendar-icon",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
            _vm._v(" "),
            _c("b-col", { staticClass: "vertical-center" }, [
              _c("p", { staticClass: "font-sm mb-0" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("toUploadHour")(_vm.startTime)) +
                    "\n          "
                ),
                _vm.endTime
                  ? _c("span", [
                      _vm._v(
                        "- " + _vm._s(_vm._f("toUploadHour")(_vm.endTime))
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _vm.eventInfo.location
          ? _c(
              "b-row",
              { staticClass: "mb-2" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "event-icon-col text-center pr-0",
                    attrs: { cols: "auto" },
                  },
                  [
                    _c("i", {
                      staticClass:
                        "text-primary fa fa-map-marker task-calendar-icon",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("b-col", { staticClass: "vertical-center" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.eventInfo.location) + "\n      "
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.eventInfo.description
          ? _c(
              "b-row",
              { staticClass: "mb-2" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "event-icon-col text-center pr-0",
                    attrs: { cols: "auto" },
                  },
                  [
                    _c("i", {
                      staticClass:
                        "text-primary fa fa-align-justify task-calendar-icon",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("b-col", { staticClass: "vertical-center" }, [
                  _c("div", {
                    staticClass:
                      "font-sm mb-0 task-description-container rich-text-editor--reset pt-0 pl-0",
                    domProps: {
                      innerHTML: _vm._s(_vm.eventInfo.description.trim()),
                    },
                  }),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.eventParticipants.length
          ? _c(
              "b-row",
              { staticClass: "mb-2" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "event-icon-col text-center pr-0",
                    attrs: { cols: "auto" },
                  },
                  [
                    _c("i", {
                      staticClass:
                        "text-primary fa fa-users task-calendar-icon",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "12" } }, [
                          _c("p", { staticClass: "mb-1 text-muted" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.eventParticipants.length) +
                                "\n              " +
                                _vm._s(
                                  _vm.$t("dashboard.calendar.participants")
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(
                      _vm.eventParticipants,
                      function (participant, index) {
                        return _c(
                          "b-row",
                          { key: index },
                          [
                            _c(
                              "b-col",
                              {
                                staticClass: "vertical-center",
                                attrs: { cols: "12" },
                              },
                              [
                                _c("icon", {
                                  staticClass:
                                    "text-primary task-calendar-icon mr-1",
                                  attrs: { name: "user-circle" },
                                }),
                                _vm._v(" "),
                                _c("p", { staticClass: "font-sm mb-0" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.participantName(participant)) +
                                      "\n            "
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }
                    ),
                  ],
                  2
                ),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }